module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shopify_setup":"Shopify Setup"},"id":{"shopify_setup":"Pengaturan Shopify"}}')
  delete Component.options._Ctor
}
